module.exports = __webpack_public_path__ + "img/PL00116.39582a89.png";